import FrontBusiness from "@/business/FrontBusiness.js";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import LivroMatriculaBusiness from "@/business/livros/LivroMatriculaBusiness";
import TextParser from "@/business/livros/TextParser";
import VueBusiness from "@/business/VueBusiness.js";
import Utils from "@/commons/Utils";
import AtoBusiness from "@/business/protocolo/AtoBusiness";
import ChecklistProcessamentoBusiness from "@/business/ChecklistProcessamentoBusiness";
import TipoServicoBusiness from "@/views/Administracao/modulos/tipo-servico/business";
import atoBusiness from "@/business/protocolo/AtoBusiness";

export default {

  async gerarMinutaLote(protocolo, ficha, atos, documentos = [], ctrl = {}, usuarioLogado = {}) {
    ficha.ctrl = {
      ultimoAto: ficha.ultimoAto,
      status: ficha.status
    }
    for (let i in atos) {
      ++ctrl.atual;
      await this.simularAto(atos[i], i, protocolo, ficha, documentos, 'gerar-minuta', usuarioLogado);
    }
    return { atos, ficha };
  },

  async gerarMinuta(protocolo, ficha, atos, documentos = [], ctrl = {}, ato, usuarioLogado = {}) {
    ficha.ctrl = {
      ultimoAto: ficha.ultimoAto,
      status: ficha.status
    }
    for (let i in atos) {
      ++ctrl.atual;
      if (ato?.id == atos[i]?.id) {
        atos[i].templateMinuta = ato.texto;
      }
      await this.simularAto(atos[i], i, protocolo, ficha, documentos, ato?.id == atos[i]?.id ? 'gerar-minuta' : 'processar', usuarioLogado);
      if (ato == atos[i]?.id) {
        return { atos, ficha };
      }
    }
    return { atos, ficha };
  },

  async simular(protocolo, ficha, atos, documentos = [], ctrl = {}, usuarioLogado) {
    ficha.ctrl = {
      ultimoAto: ficha.ultimoAto,
      status: ficha.status
    }

    let livroFolhaSimulado = {};
    try {
      let dados = await atoBusiness.simularLivroFolhaNotas(protocolo.id);
      (dados || []).forEach(d => { livroFolhaSimulado[d.atoId] = d; });
    } catch (e) {
      // Se não houver dados, segue sem livro/folha
    }

    for (let i in atos) {
      ++ctrl.atual;
      atos[i].livroFolhaSimulado = livroFolhaSimulado[atos[i].id] || null;
      await this.simularAto(atos[i], i, protocolo, ficha, documentos, 'completo', usuarioLogado);
    }

    return { atos, ficha };
  },

  async simularAto(ato, posicao, protocolo, ficha, documentos, modo = 'completo', usuarioLogado) {
    ato.envolvidos = ato?.envolvidos || [];
    let simulacaoCompleta = modo == 'completo' || modo == 'gerar-minuta';
    ato.erros = [];

    if (ficha.status == 'PENDENTE') {
      ficha.prematricula = true;
    }

    const criarErro = (msg, area = '', tipo = 'erro') => {
      ato.erros.push({ area, msg, tipo });
    };

    ato.ficha = Utils.clone(ficha);
    ato.codigo = (ficha.status == 'PENDENTE' || (ato.tipo || ato.tipoServico?.opcoes?.tipoAto) === 'ABERTURA')
      ? 0 : (parseInt(ficha.ultimoAto || 0, 10) + 1);

    ato.codigoStr = '';
    ficha.ultimoAto = ato.codigo;

    await atoBusiness.validarAto(protocolo.id, ato.livro, ato.id, simulacaoCompleta, modo).then(alertas => {
      alertas.map(a => {
        criarErro(a.message, a.area, a.tipo);
      });
    });

    let envolvidosPromise = [];
    for (let envolvido of ato.envolvidos) {
      if (simulacaoCompleta || modo == 'gerar-minuta') {
        let p = IndicadorPessoalBusiness.getVersaoByIdComCache(envolvido.indicadorPessoalVersaoId);
        envolvidosPromise.push(p);
        p.then(pessoa => {
          envolvido.indicadorPessoalVersao = pessoa;
        });
      }
    }
    if (envolvidosPromise.length) {
      await Promise.all(envolvidosPromise);
    }

    (ato.tipoServico?.opcoes?.papeisObrigatorios || []).forEach(papel => {
      if (!ato.envolvidos.find(e => e.papel == papel)) {
        criarErro(`Necessário informar uma parte envolvida como ${TipoServicoBusiness.nomePapel(papel)}`, 'envolvidos', 'erro');
      }
    });

    if (ato?.exigencias?.length) {
      criarErro("O ato possui exigências", 'exigencia', 'erro');
    }

    if (simulacaoCompleta && (!ato?.indices?.respondidos || ato?.indices?.respondidos < ato?.indices?.quantidade)) {
      if (!ato.legado) {
        const item = await AtoBusiness.getById(protocolo.id, ato.id);
        const vinculos = { documentos };
        if (item.envolvidos) vinculos.envolvidos = item.envolvidos;

        const resultados = await ChecklistProcessamentoBusiness.contarChecklistsDoAto(item, vinculos);

        for (let checklist of (resultados || [])) {
          if (checklist.contador.quantidade > 0 && checklist.contador.respondidos < checklist.contador.quantidade) {
            let msgErro = 'Checklist está incompleto: ';
            let titulo = checklist.titulo || checklist.nome;
            let area = `checklist-${checklist.id}.checklist-group .nao-respondido`;
            if (VueBusiness.getVueRoot().getPermission({ id: 'PERMITIR_REGISTRAR_CHECKLIST_INCOMPLETO_PROTOCOLO', dominio: protocolo?.dominio || 'PROTOCOLO_NOTAS' })) {
              criarErro(msgErro + titulo, area, 'alerta');
            } else {
              criarErro(msgErro + titulo, area, 'erro');
            }
          }
        }
      }
    }

    if (['CANCELAMENTO', 'ENCERRAMENTO'].includes(ato.tipoServico?.opcoes?.operacaoIndicador)) {
      let msg = `Este ato ${ato.tipoServico?.opcoes?.operacaoIndicador == 'CANCELAMENTO' ? 'cancelará' : 'encerrará'} ${ficha.status == 'PENDENTE' || ficha.prematricula ? 'o pré-' : 'o '}${FrontBusiness.nomearLivro(ficha.livro).toLowerCase()}.`;
      criarErro(msg, null, 'warning');
      ficha.status = ato.tipoServico.opcoes.operacaoIndicador == 'CANCELAMENTO' ? 'CANCELADA' : 'ENCERRADA';
    }

    if (simulacaoCompleta) {
      if (modo == 'gerar-minuta' || !ato?.tipoServico?.opcoes?.editarMinuta) {
        ato.minuta = await LivroMatriculaBusiness.gerarMinutaAto(
          Utils.clone(ato), Utils.clone(ficha), Utils.clone(protocolo), Utils.clone(documentos), usuarioLogado
        );
      } else {
        ato.minuta = ato.texto;
      }

      if (ato?.tipoServico?.opcoes?.editarMinuta) {
        const minutaInvalida = TextParser.minutaInvalida(ato.minuta);
        if (minutaInvalida) {
          criarErro(minutaInvalida, 'minuta', 'erro');
        }
      }
    }

    if (ficha.status == 'PENDENTE') {
      const livrosTabelionatoPadrao = ['ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'TESTAMENTO', 'ATA_NOTARIAL'];
      const tipoAto = ato.tipoServico?.opcoes?.tipoAto;
      ficha.status = (tipoAto === 'ABERTURA' && livrosTabelionatoPadrao.includes(ficha.livro)) ? 'LAVRADO' : 'ABERTA';
    }

    if (ato.custas?.erro) {
      criarErro(ato.custas.erro?.descricao || ato.custas.erro, '', 'erro');
    }
  },
}
